/* file description */
import { Popover } from 'antd';
import React, { FC, useEffect, useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { UploadRenderProps } from './type';
import { WaterMark } from '@cui/pro-components';
import { useAsyncEffect } from 'ahooks';
import { getUserInfoCache } from '@/api/system';

export const UploadRender: FC<UploadRenderProps> = ({
  targerValue,
  fileType,
  setViewValue,
}) => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  const [waterMarkerText, setWaterMarkerText] = useState('');

  useAsyncEffect(async () => {
    const userInfo = await getUserInfoCache();
    setWaterMarkerText(
      `${userInfo.user.userName}（${userInfo.user.userAccount}）`,
    );
  }, []);

  const picElement = (type: string) => {
    return (
      <div>
        <WaterMark content={waterMarkerText} gapX={130} gapY={130}>
          <img
            style={{
              maxWidth: '60vw',
              maxHeight: '70vh',
              width: type === 'init' ? 'unset' : 'auto',
              height: type === 'init' ? '32px' : 'auto',
            }}
            src={targerValue}
          />
        </WaterMark>
      </div>
    );
  };

  if (!targerValue) {
    return '';
  }
  if (['png', 'jpg', 'jpeg'].includes(fileType.toLowerCase())) {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Popover content={picElement('preview')} title="预览" trigger="click">
          {picElement('init')}
        </Popover>
      </div>
    );
  } else if (['pdf'].includes(fileType.toLowerCase())) {
    const name = targerValue.split('/').pop();
    return (
      <div style={{ height: '32px', overflow: 'hidden' }}>
        <a href={targerValue} target="blank">
          {name}
        </a>
      </div>
    );
  } else {
    const fileName =
      targerValue?.match(/\/([^/?#]+)[^/]*$/)?.[1] || targerValue;

    setViewValue(fileName);
    return fileName;
  }
};
export default UploadRender;
